import axios from 'axios'
// import Vue from 'vue';
// import store from '../store';
// import {router} from '../router/index';
// import { Message } from 'element-ui'

// let vm = new Vue();
// let baseURL = "http://www.zzskzy.com/api/";
// if (process.env.NODE_EVN === "development") {
//   console.log("开发环境");
// }else{
//   console.log("生产环境");
// }
// 创建axios实例
const service = axios.create({
  //  当执行 npm run dev 时候 => .evn.develoment =>/api=>跨域代理
  //  配置环境变量有点问题需要自己手动切换
  // baseURL: '/api2/', // 本地开发用这个
  baseURL: 'http://www.zzskzy.com/api/', // 线上服务器 用这个
  timeout: 500000 // c超时时间5秒
})
// if (process.env.NODE_EVN === 'development') {
//   baseURL = '/api2/'
// }
//  REQUEST 请求异常拦截
service.interceptors.request.use(
  config => {
    // console.log(process.env.NODE_ENV, 'process.env.NODE_ENV')

    // const token = localStorage.getItem('token')
    // 将Token添加到请求头里面
    // token && (config.headers.Token = token)
    return config
  },
  err => {
    // 错误处理
    // Message.error({ message: '请求超时!' })
    return Promise.resolve(err)
  }
)

// 响应拦截
service.interceptors.response.use(response => {
  const data = response.data
  return data
})
// 导出axios实例
export default service
